var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.4641C3.33333 16.9245 3.33333 13.0755 6 11.5359L16.5 5.47372C19.1667 3.93412 22.5 5.85863 22.5 8.93783L22.5 21.0622C22.5 24.1414 19.1667 26.0659 16.5 24.5263L6 18.4641Z",
    fill: "#36ACD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.4641C23.3333 16.9245 23.3333 13.0755 26 11.5359L36.5 5.47372C39.1667 3.93412 42.5 5.85863 42.5 8.93783L42.5 21.0622C42.5 24.1414 39.1667 26.0659 36.5 24.5263L26 18.4641Z",
    fill: "#36ACD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/Four.d5aaa936dffbe4c392b0579283447fc6.svg";
export { ForwardRef as ReactComponent };